export default "__VITE_ASSET__CuZ1S$9___"